import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/givingBack',
    component: LAYOUT,
    redirect: '/givingBack/news',
    meta: { title: '回馈母校', showNavPanel: true },
    children: [
      // {
      //   path: 'project',
      //   name: '捐赠项目',
      //   component: () => import('@/views/givingBack/project.vue'),
      //   meta: { title: '捐赠项目' },
      // },
      {
        path: 'news',
        name: '捐赠新闻',
        component: () => import('@/views/givingBack/news.vue'),
        meta: { title: '捐赠新闻' },
      },
      {
        path: 'record',
        name: '捐赠纪事',
        component: () => import('@/views/givingBack/record.vue'),
        meta: { title: '捐赠纪事' },
      },
      // {
      //   path: 'method',
      //   name: '捐赠方式',
      //   component: () => import('@/views/givingBack/method.vue'),
      //   meta: { title: '捐赠方式' },
      // },
      // {
      //   path: 'plan',
      //   name: '义工计划',
      //   component: () => import('@/views/givingBack/plan.vue'),
      //   meta: { title: '义工计划' },
      // },
    ],
  },
]
